/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Add_FolderInputs */

const en_mobile_add_folder = /** @type {(inputs: Mobile_Add_FolderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add folder`)
};

const es_mobile_add_folder = /** @type {(inputs: Mobile_Add_FolderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agregar carpeta`)
};

/**
* | output |
* | --- |
* | "Add folder" |
*
* @param {Mobile_Add_FolderInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_add_folder = /** @type {((inputs?: Mobile_Add_FolderInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Add_FolderInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_add_folder(inputs)
	return en_mobile_add_folder(inputs)
});